var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[(_vm.modalContent === 'countries')?_c('Countries'):_c('div',[_vm._v("MODAL "+_vm._s(_vm.modalContent))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }